import * as React from 'react';
import { Link } from 'react-router-dom';

import { DataTableView, Column, ToolbarVisibility } from 'src/core/ui/data-table.view';

interface Props extends ComponentViewProps<DataSet<AgentSummary>> {
	isReadonly: boolean;
	onItemDoubleClicked?: (item: AgentSummary) => void;
}

export class AgentListView extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	render() {
		const { model, isReadonly, onItemDoubleClicked, setBusy } = this.props;
		const columns = [
			{
				key: 'name',
				title: 'Name',
				dataIndex: 'name',
				render: (text, record: AgentSummary) => <Link to={`/bookings/agents/${record.id}`}>{text}</Link>,
			},
			{
				key: 'managedByUserName',
				title: 'User',
				dataIndex: 'managedByUserName',
			},
			{
				key: 'creditNumber',
				title: 'Credit',
				dataIndex: 'creditNumber',
				render: (text, record) => {
					return `$${record.creditNumber}`;
				}
			}
		];

		const hierarchyParams = isReadonly
			? {}
			: {
				hierarchyParent: ['responsibleAgentId'],
				hierarchyHasChildren: (item) => item.hasChildren,
				hierarchyId: ['id']
			};

		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						model={model}
						setBusy={setBusy}
						columns={columns}
						itemDoubleClick={(item) => {
							if (onItemDoubleClicked) {
								onItemDoubleClicked(item);
							}
						}}
						{...hierarchyParams}
						hideToolbar={isReadonly ? ToolbarVisibility.hideModifyButtons : null}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/agents/list/agent-list.view.tsx